import AnimationRevealPage from "helpers/AnimationRevealPage";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground";
import SimpleWithSideImage from "components/faqs/SimpleWithSideImage";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings";
import dashboardImg from "../images/our-analyses.png"
import Analyse1 from "../components/analyses/Analyse1";
import translate from "../lang/translate";
import Analyse2 from "../components/analyses/Analyse2";
import React, {useRef} from "react";
import {useSelector} from "react-redux";
import {LangProvider} from "../lang";
import Analyse3 from "../components/analyses/Analyse3";
import Analyse4 from "../components/analyses/Analyse4";
import Analyse5 from "../components/analyses/Analyse5";
import Analyse6 from "../components/analyses/Analyse6";
import Analyse7 from "../components/analyses/Analyse7";
import Analyse71 from "../components/analyses/Analyse71";
import Analyse72 from "../components/analyses/Analyse72";
import Analyse73 from "../components/analyses/Analyse73";
import Analyse74 from "../components/analyses/Analyse74";
import Analyse8 from "../components/analyses/Analyse8";
import Analyse9 from "../components/analyses/Analyse9";
import Analyse10 from "../components/analyses/Analyse10";


const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;

const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;


function OurAnalyses({ headingText = "Terms And Condition" }) {
    const locale = useSelector(state => state.locale);
    const ref1 = useRef();
    const ref2 = useRef();
    const ref3 = useRef();
    const ref4 = useRef();
    const ref5 = useRef();
    const ref6 = useRef();
    const ref7 = useRef(null);
    const ref71 = useRef();
    const ref72 = useRef();
    const ref73 = useRef();
    const ref74 = useRef();
    const ref8 = useRef();
    const ref9 = useRef();
    const ref10 = useRef();
    const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

    return (
        <LangProvider locale={locale}>
            <AnimationRevealPage>
                <Header />
                <SimpleWithSideImage />
                <Container>
                    <ContentWithPaddingXl>
                        <Text>
                            <Text>
                                <Analyse1
                                    ref={ref1}
                                    title={translate('our_analyses.1.title')}
                                    d1={translate('our_analyses.1.d1')}
                                    d2={translate('our_analyses.1.d2')}
                                    d3={translate('our_analyses.1.d3')}
                                    d4={translate('our_analyses.1.d4')}
                                    d5={translate('our_analyses.1.d5')}
                                    d6={translate('our_analyses.1.d6')}
                                    d7={translate('our_analyses.1.d7')}
                                    d8={translate('our_analyses.1.d8')}
                                    d9={translate('our_analyses.1.d9')}
                                />
                                <Analyse2
                                    ref={ref2}
                                    title={translate('our_analyses.2.title')}
                                    d1={translate('our_analyses.2.d1')}
                                    d2={translate('our_analyses.2.d2')}
                                    image1={translate('our_analyses.2.image1')}
                                    image2={translate('our_analyses.2.image2')}
                                    d3={translate('our_analyses.2.d3')}
                                    d4={translate('our_analyses.2.d4')}
                                />
                                <Analyse3
                                    ref={ref3}
                                    title={translate('our_analyses.3.title')}
                                    d1={translate('our_analyses.3.d1')}
                                    d2={translate('our_analyses.3.d2')}
                                    d3={translate('our_analyses.3.d3')}
                                    image1={translate('our_analyses.3.image1')}
                                    image2={translate('our_analyses.3.image2')}
                                    image3={translate('our_analyses.3.image3')}
                                />
                                <Analyse4
                                    ref={ref4}
                                    title={translate('our_analyses.4.title')}
                                    d1={translate('our_analyses.4.d1')}
                                    d2={translate('our_analyses.4.d2')}
                                    d3={translate('our_analyses.4.d3')}
                                    d4={translate('our_analyses.4.d4')}
                                    d5={translate('our_analyses.4.d5')}
                                    d6={translate('our_analyses.4.d6')}
                                    d7={translate('our_analyses.4.d7')}
                                    image1={translate('our_analyses.4.image1')}
                                    image2={translate('our_analyses.4.image2')}
                                />
                                <Analyse5
                                    ref={ref5}
                                    title={translate('our_analyses.5.title')}
                                    d1={translate('our_analyses.5.d1')}
                                    d21={translate('our_analyses.5.d2.1')}
                                    d22={translate('our_analyses.5.d2.2')}
                                    d23={translate('our_analyses.5.d2.3')}
                                    d24={translate('our_analyses.5.d2.4')}
                                    d25={translate('our_analyses.5.d2.5')}
                                    d26={translate('our_analyses.5.d2.6')}
                                    d27={translate('our_analyses.5.d2.7')}
                                    d3={translate('our_analyses.5.d3')}
                                    d4={translate('our_analyses.5.d4')}
                                    d5={translate('our_analyses.5.d5')}
                                    d6={translate('our_analyses.5.d6')}
                                    d7={translate('our_analyses.5.d7')}
                                    subtitle1={translate('our_analyses.5.subtitle1')}
                                    subtitle2={translate('our_analyses.5.subtitle2')}
                                    image1={translate('our_analyses.5.image1')}
                                />
                                <Analyse6
                                    ref={ref6}
                                    title={translate('our_analyses.6.title')}
                                    d1={translate('our_analyses.6.d1')}
                                    d2={translate('our_analyses.6.d2')}
                                    d3={translate('our_analyses.6.d3')}
                                    d4={translate('our_analyses.6.d4')}
                                    d5={translate('our_analyses.6.d5')}
                                    d6={translate('our_analyses.6.d6')}
                                    image1={translate('our_analyses.6.image1')}
                                    image2={translate('our_analyses.6.image2')}
                                    image3={translate('our_analyses.6.image3')}
                                />
                                <Analyse7
                                    ref={ref7}
                                    title={translate('our_analyses.7.title')}
                                    d1={translate('our_analyses.7.d1')}
                                    d2={translate('our_analyses.7.d2')}
                                    d3={translate('our_analyses.7.d3')}
                                    d4={translate('our_analyses.7.d4')}
                                    d5={translate('our_analyses.7.d5')}
                                    d6={translate('our_analyses.7.d6')}
                                    strong_desc1={translate('our_analyses.7.strong_desc1')}
                                    strong_desc2={translate('our_analyses.7.strong_desc2')}
                                    image1={translate('our_analyses.7.image1')}
                                />
                                <Analyse71
                                    ref={ref71}
                                    title={translate('our_analyses.7.1.title')}
                                    d1={translate('our_analyses.7.1.d1')}
                                    d2={translate('our_analyses.7.1.d2')}
                                    d3={translate('our_analyses.7.1.d3')}
                                    ex1={translate('our_analyses.7.1.ex1')}
                                    ex2={translate('our_analyses.7.1.ex2')}
                                    image1={translate('our_analyses.7.1.image1')}
                                    image2={translate('our_analyses.7.1.image2')}
                                />
                                <Analyse72
                                    ref={ref72}
                                    title={translate('our_analyses.7.2.title')}
                                    d1={translate('our_analyses.7.2.d1')}
                                    d2={translate('our_analyses.7.2.d2')}
                                    d3={translate('our_analyses.7.2.d3')}
                                    d4={translate('our_analyses.7.2.d3')}
                                    ex1={translate('our_analyses.7.2.ex1')}
                                    ex2={translate('our_analyses.7.2.ex2')}
                                    image1={translate('our_analyses.7.2.image1')}
                                />
                                <Analyse73
                                    ref={ref73}
                                    title={translate('our_analyses.7.3.title')}
                                    d1={translate('our_analyses.7.3.d1')}
                                    d2={translate('our_analyses.7.3.d2')}
                                    ex={translate('our_analyses.7.3.ex')}
                                />
                                <Analyse74
                                    ref={ref74}
                                    title={translate('our_analyses.7.4.title')}
                                    d1={translate('our_analyses.7.4.d1')}
                                    d2={translate('our_analyses.7.4.d2')}
                                    d3={translate('our_analyses.7.4.d3')}
                                    ex1={translate('our_analyses.7.4.ex1')}
                                    ex2={translate('our_analyses.7.4.ex2')}
                                />
                                <Analyse8
                                    ref={ref8}
                                    title={translate('our_analyses.8.title')}
                                    d1={translate('our_analyses.8.d1')}
                                    d2={translate('our_analyses.8.d2')}
                                    d3={translate('our_analyses.8.d3')}
                                    d4={translate('our_analyses.8.d4')}
                                    d5={translate('our_analyses.8.d5')}
                                    d6={translate('our_analyses.8.d6')}
                                    d7={translate('our_analyses.8.d7')}
                                    d8={translate('our_analyses.8.d8')}
                                    d9={translate('our_analyses.8.d9')}
                                />
                                <Analyse9
                                    ref={ref9}
                                    title={translate('our_analyses.9.title')}
                                    d1={translate('our_analyses.9.d1')}
                                    d2={translate('our_analyses.9.d2')}
                                />
                                <Analyse10
                                    ref={ref10}
                                    title={translate('our_analyses.10.title')}
                                    d1={translate('our_analyses.10.d1')}
                                    d2={translate('our_analyses.10.d2')}
                                    d31={translate('our_analyses.10.d3.1')}
                                    d32={translate('our_analyses.10.d3.2')}
                                    d33={translate('our_analyses.10.d3.3')}
                                    d4={translate('our_analyses.10.d4')}
                                    d5={translate('our_analyses.10.d5')}
                                />
                            </Text>

                        </Text>
                    </ContentWithPaddingXl>
                </Container>
                <Footer />

            </AnimationRevealPage>
        </LangProvider>
    );
}

export default OurAnalyses;
